module.exports = __webpack_public_path__ + "img/one-disabled-big.021fdd1d.svg";